var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-wrapper',{attrs:{"isSpinner":_vm.isSpinner}},[_c(_vm.isConnected,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }